module.exports = __webpack_public_path__ + "media/images/ultrasync_logo-c523e29c8786861b051b562d4ebfe3a7.jpg";